// import { SearchByReferenceId } from '../../schemas/Search/Search.schema';
import { setObject, getObject } from '../../utils/common';
import { load } from './Loads.model';
import { stopActivityProps } from '../stopActivity.model';

interface SearchByReferenceId {
  managedEquipmentCapability?: string | null;
  nonManagedEquipmentCapability?: string | null;
  userId?: string;
  carrierId?: string;
  carrierScac?: string;
  carrierTier?: string;
  userRole?: string;
  loadNumberAlias?: string;
  page?: number;
}
export class SearchById implements SearchByReferenceId {

  page: number = 0;
  managedEquipmentCapability?: string | null = '';
  nonManagedEquipmentCapability?: string | null = '';
  userId?: string;
  carrierId?: string;
  carrierScac?: string;
  userRole?: string;
  loadNumberAlias?: string;
  carrierTier?: string;

  getRequestPayload() {
    const excludedProperty = [ "carrierTier" ];
    const input: { [key: string]: any } = {};
    for (const [key, value] of Object.entries(this)) {
      if (typeof value !== "function" && !excludedProperty.includes(key)) input[key] = value;
    }
    const {similarLoads, ...updatedLoad} = load;
    return {
      query: {
        searchLoadByReferenceV2: {
          __args: {
            input
          },
          totalRecords: true,
          loadPostings: {
            ...updatedLoad,
            exclusiveLoad: true,
            specialServices: {
              serviceDesc: true,
              specialServiceDesc: true,
            }
          },
          shipments: {
            shipmentId: true,
            capacityType: true,
            documentStatus:true,
            invoiceCreatedDateTime:true,
            transportMode: true,
            totalWeight: true,
            weightUOM: true,
            totalDistance: true,
            distanceUOM: true,
            numberOfStops: true,
            sourceTMS: true,
            shipmentTenderedCarriers : {
              recordId : true,
              shipmentId : true,
              carrierId : true,
              offeredRate : true
            },
            division: true,
            driverAssignmentStatus: true,
            assignedCarrierId: true,
            assignedTMSCarrierId: true,
            isHazardous: true,
            isHighValue: true,
            isTemperatureControlled: true,
            readyDateTime: true,
            readyDateTimeZone: true,
            equipmentType: true,
            predecessorShipmentId: true,
            successorShipmentId: true,
            assignmentStatus: true,
            executionStatus: true,
            shipmentServices: {
              serviceDescription: true
            },
            startState: true,
            startCity: true,
            startDateTime: true,
            loadStop: {
              stopId: true,
              locationId: true,
              stopType: true,
              sequenceNo: true,
              locationName: true,
              addressLine1: true,
              addressLine2: true,
              city: true,
              state: true,
              country: true,
              postalCode: true,
              timeZone: true,
              longitude: true,
              latitude: true,
              estimatedArrivalDateTime: true,
              appointmentState: true,
              plannedArrivalDateTime: true,
              actualArrivalDateTime: true,
              estimatedStopDuration: true,
              plannedEtaDateTime: true,
              plannedDepartureDateTime: true,
              actualDepartureDateTime: true,
              appointmentEarlyDateTime: true,
              appointmentLateDateTime: true,
              estimatedStopDurationUom: true,
              actualETADateTime: true,
              isTrailerInSet: true,
              stopActivity: stopActivityProps,
              stopReference: {
                id: true,
                type: true,
                value: true,
                stopId: true,
                shipmentId: true,
                display: true
              },
              stopCommodity :{
                commodityDesc:true,
                 packagingType : true 
             },
            },
            shipmentInvolvedParties: {
              id: true,
              partyId: true,
              partyType: true,
              partyName: true,
              partyEmail: true,
              partyPhone: true
            },
            shipmentReferences: {
              id: true,
              type: true,
              value: true,
              stopId: true,
              shipmentId: true,
              display: true
            },
            assignmentTransaction: {
              transactionId: true,
              shipmentId: true,
              transactionType: true,
              driverId: true,
              driverPhone: true,
              driverEmail: true,
              status: true,
              driverName: true
            },
            shipmentCostItems : { 
              costBreakdownDescription:true, 
              costBreakdownRate:true,
              costBreakdownRateQlfr:true, 
              costBreakdownQty:true, 
              costBreakdownTotalAmount:true 
            },
            totalCostAmount:true,
            costCurrency:true,
            carrierContactInfo: {
              carrierPhone: true,
              carrierName: true,
              carrierEmail: true,
              defaultCarrierPhone: true,
              manageEquipmentPhone: true,
              nonManageEquipmentPhone: true
            },
            automatedTrackingInProgress: true,
            carrierPro: true,
            shipmentState: true
          }
        }
      }
    };
  }
  persistLoads(_loads: []) {
    return setObject('Search-Loads', _loads);
  }

  getLoads() {
    return getObject('Search-Loads');
  }
  recentLoads(_loads: []) {
    return setObject('Recent-Loads', _loads);
  }
  getRecentLoads() {
    return getObject('Recent-Loads');
  }
  favoriteLoads(_loads: []) {
    return setObject('Favorite-Loads', _loads);
  }
  getfavoriteLoadss() {
    return getObject('Favorite-Loads');
  }
}
const searchByReferenceIdModel = new SearchById();
Object.freeze(searchByReferenceIdModel);

export default SearchByReferenceId;
